// extracted by mini-css-extract-plugin
export default {"row-cell":"site-table-row_row-cell__xK+PU","first-cell":"site-table-row_first-cell__GCU94","last-cell":"site-table-row_last-cell__l16vE"};